import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Loader2, Zap } from "lucide-react";
import { useCredits } from "../context/CreditsContext";
import { api } from "../lib/api";
import { buyCredits } from "../lib/buyCredits";

const usePopularPack = (enabled) => {
  const [pack, setPack] = useState(null);
  useEffect(() => {
    if (enabled) api.creditPacks().then((ps) => setPack(ps.find((p) => p.popular) || ps[0] || null)).catch(() => {});
  }, [enabled]);
  return pack;
};

const btn = "h-7 px-3 rounded-full bg-slate-900 text-white text-xs font-semibold flex items-center gap-1.5 hover:bg-slate-700 disabled:opacity-60 transition-colors";

export const LowBalanceBar = ({ className = "" }) => {
  const { credits, pricing, refresh } = useCredits();
  const low = !!credits && !!pricing.lowAt && credits.total < pricing.lowAt;
  const pack = usePopularPack(low);
  const [busy, setBusy] = useState(false);
  if (!low) return null;
  const out = credits.total <= 0;

  const buy = () => {
    setBusy(true);
    buyCredits(pack.id, {
      onSuccess: (r) => { toast.success(`${r.credits_added || pack.credits} credits added — happy building!`); refresh(); setBusy(false); },
      onError: (m) => { toast.error(m); setBusy(false); },
      onDismiss: () => setBusy(false),
    });
  };

  return (
    <div role="status" data-testid="low-balance-bar"
      className={`relative z-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 px-4 py-2 text-sm bg-amber-50 border-b border-amber-200 text-amber-900 ${className}`}>
      <Zap size={14} className="fill-amber-400 text-amber-500 shrink-0" />
      <span data-testid="low-balance-message">
        {out ? "You're out of credits — top up to keep building." : <>You're running low — <b className="font-mono">{credits.total}</b> credit{credits.total === 1 ? "" : "s"} left. Top up now so your next build doesn't stop.</>}
      </span>
      {pack ? (
        <>
          <button onClick={buy} disabled={busy} data-testid="low-balance-topup" className={btn}>
            {busy ? <Loader2 size={12} className="animate-spin" /> : <Zap size={12} className="fill-amber-300 text-amber-300" />}
            Top up {pack.credits.toLocaleString("en-IN")} credits · ₹{pack.price_inr.toLocaleString("en-IN")}
          </button>
          <Link to="/billing" data-testid="low-balance-more" className="text-xs text-amber-800 underline underline-offset-2 hover:text-amber-950">More options</Link>
        </>
      ) : (
        <Link to="/billing" data-testid="low-balance-topup" className={btn}>Top up now <ArrowRight size={12} /></Link>
      )}
    </div>
  );
};

export default LowBalanceBar;
